import { render, staticRenderFns } from "./purgrnview.vue?vue&type=template&id=07ef7f10&scoped=true&"
import script from "./purgrnview.vue?vue&type=script&lang=js&"
export * from "./purgrnview.vue?vue&type=script&lang=js&"
import style0 from "./purgrnview.vue?vue&type=style&index=0&id=07ef7f10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef7f10",
  null
  
)

export default component.exports